import { dateFormat } from '@cp/src/utils/DateHelper';
import { VIEW_MODE } from '../leaderboard/const';

export const displayAmountInCrore = (amount: number): string => {
  const formattedNum = (amount / 10000000).toFixed(2);
  return `₹ ${formattedNum} Cr.`;
};

export const isNumberGreaterThanCrore = (num: number): boolean => num >= 10000000;

export const getMonth = (type: VIEW_MODE, withoutYear?: boolean) => {
  const current = new Date();
  current.setDate(1);
  if (type == VIEW_MODE.PREVIOUS) {
    current.setMonth(current.getMonth() - 1);
    return dateFormat(current, withoutYear ? 'MMMM' : 'MMM YYYY');
  }
  return dateFormat(current, withoutYear ? 'MMMM' : 'MMM YYYY');
};

export const shortNumberNotationStartingWithLakhs = (value = 0, decimals = 2, separator = '') => {
  if (!value) return '';
  const parsedValue = Number(value);
  if (parsedValue >= 1e7) {
    return (parsedValue / 1e7).toFixed(decimals) + `${separator}Cr`;
  }
  return (parsedValue / 1e5).toFixed(decimals) + `${separator}L`;
};

export const transformData = (d: any) => {
  return {
    name: d?.label,
    y: d?.value,
    value: shortNumberNotationStartingWithLakhs(d?.value, 2, ' ')
  };
};

export const tabOptions: { label: string; value: string }[] = [
  {
    label: getMonth(VIEW_MODE.PREVIOUS, true),
    value: String(VIEW_MODE.PREVIOUS)
  },
  {
    label: getMonth(VIEW_MODE.CURRENT, true),
    value: String(VIEW_MODE.CURRENT)
  }
];
export const AGENCY_NAME_LIMIT = 20;

export const getAgencyName = (agencyName: string) => {
  if ((agencyName?.length as number) > 20) return agencyName?.substring(0, 20) + '...';
  return agencyName || '';
};
